import { LeaderboardUserBase } from "model/Leaderboard/User/LeaderboardUser";
import { nonUndefined } from "Utility";
import {
  FsLeaderboardSegment,
  FsTournamentLeaderboardUser,
} from "db/model/leaderboard/FsTournamentLeaderboardUser";
import {
  LeaderboardSegment,
  TournamentLeaderboardUser,
} from "model/Leaderboard/User/TournamentLeaderboardUser";

export const mapTournamentLeaderboardUser = (
  fsModel: FsTournamentLeaderboardUser,
  base: LeaderboardUserBase
): TournamentLeaderboardUser | undefined => {
  if (!fsModel.segments) {
    return undefined;
  }

  return {
    ...base,
    segments: nonUndefined(fsModel.segments.map(mapLeaderboardSegment)),
  };
};

const mapLeaderboardSegment = (
  fsModel: FsLeaderboardSegment
): LeaderboardSegment | undefined => {
  if (!fsModel.segmentId || !fsModel.points) {
    return undefined;
  }

  return {
    segmentId: fsModel.segmentId,
    points: fsModel.points,
  };
};
